<template>
  <div class="nav-session__phone" @click.stop>
    <template v-if="!editing">
      <p class="nav-session__phone-value">
        <span v-if="currentPhone">{{ phoneLabel }}</span>
        <span v-else class="nav-session__phone-empty">Intet telefonnummer</span>
      </p>
      <button
        type="button"
        class="button is-small nav-session__phone-edit"
        aria-label="Rediger telefonnummer"
        @click="startEdit"
      >
        <Icon name="pencil" size="sm" />
        <span>Rediger</span>
      </button>
    </template>
    <template v-else>
      <input
        ref="phoneInput"
        v-model="draft"
        class="input is-small"
        type="tel"
        maxlength="40"
        placeholder="Telefonnummer"
        :disabled="saving"
        @keydown.enter.prevent="save"
        @keydown.esc.prevent="cancel"
      >
      <div class="nav-session__phone-actions">
        <button
          type="button"
          class="button is-small is-primary"
          :disabled="saving"
          @click="save"
        >Gem</button>
        <button
          type="button"
          class="button is-small"
          :disabled="saving"
          @click="cancel"
        >Annuller</button>
      </div>
      <p v-if="error" class="nav-session__phone-error">{{ error }}</p>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import axios from 'axios'
import { useComposition } from '@/compositions/composition'
import { friendlyError } from '@/auth/sessionApi'
import { apiUrl, authApi } from '@/auth/config'
import { formatPhoneLabel, normalizePhone } from '@/phone'
import Icon from '@/components/Icon.vue'

export default defineComponent({
  name: 'NavSessionPhone',
  components: { Icon },
  setup() {
    const { global } = useComposition()
    return { global }
  },
  data() {
    return {
      editing: false,
      draft: '',
      saving: false,
      error: ''
    }
  },
  computed: {
    currentPhone() {
      return normalizePhone((this.global.user && this.global.user.phone) || '')
    },
    phoneLabel() {
      return formatPhoneLabel(this.currentPhone)
    }
  },
  methods: {
    startEdit() {
      this.error = ''
      this.draft = this.currentPhone
      this.editing = true
      this.$nextTick(() => {
        const input = this.$refs.phoneInput
        if (input && typeof input.focus === 'function') {
          input.focus()
          input.select()
        }
      })
    },
    cancel() {
      this.editing = false
      this.draft = ''
      this.error = ''
      this.saving = false
    },
    async save() {
      const phone = normalizePhone(this.draft)
      if (phone === this.currentPhone) {
        this.cancel()
        return
      }
      this.saving = true
      this.error = ''
      try {
        const response = await axios.post(
          apiUrl(authApi.currentUser) + '?mode=updatePhone',
          { phone },
          { withCredentials: true }
        )
        if (response.data && response.data.success) {
          this.global.user.phone = response.data.phone || phone
          this.cancel()
        } else {
          this.error = (response.data && response.data.friendly && response.data.friendly.da)
            || 'Telefonnummeret kunne ikke gemmes.'
        }
      } catch (err) {
        this.error = friendlyError(err, 'Telefonnummeret kunne ikke gemmes.')
      } finally {
        this.saving = false
      }
    }
  }
})
</script>
